import { Component, AfterContentInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { SubstitutionDTO } from '../../api/plyca-dtos-v2';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { finalize } from 'rxjs/operators';
import { Configuration } from '../../conf/app.constants';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { SubstitutionEditionComponent } from './substitution.edition.component';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { FormConfig } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { Observable, of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { UserService } from '../../user.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ConfirmationService } from 'primeng-lts/api';
import { PropertyService } from '../../properties/property.service';
import { ActivatedRoute } from '@angular/router';
import { UserDTO } from '../../api/plyca-dtos';

@Component({
  selector: 'substitutionPanel',
  templateUrl: 'substitutionPanel.template.html',
  providers: [DatePipe]
})
export class substitutionPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;
  substitutions: SubstitutionDTO[] = [];

  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;
  public model1: any;
  public parcialSubstitutionProfile = false;
  private usuidParam: string;



  constructor(
    public plycaService: PlycaDataService,
    public configuration: Configuration,
    public helpService: HelpService,
    public uiService: UIService,
    public userService: UserService,
    public waitService: WaitLoadingService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    public dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private datePipe: DatePipe,
    private plycaErrorHandler: PlycaErrorHandler,
    private propertyService: PropertyService,
    public translate: TranslateService,
    private route: ActivatedRoute
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.SUBSTITUTIONS));
    this.subscribe(this.route.queryParams, params => {

      this.usuidParam = params['userid'];
    });
    this.dtoToModel();
    this.loadConfigParcialSubstitution();


  }

  loadConfigParcialSubstitution() {
    this.subscribe(this.propertyService.getProperty('FraMtoSuplencias.CheckAsociarPerfiles.Visible', null), (value: string) => {
      this.parcialSubstitutionProfile = this.userService.hasRoles(value);
    });
  }


  dtoToModel() {

    this.model1 = {};

    // usuario conectado, necesario para organismo hex
    this.model1.loggedUser = this.userService.getUser();
    if (this.usuidParam) {
      this.model1.replacedUser = new UserDTO();
      this.model1.replacedUser.identifier = this.usuidParam;


    }
    // fecha de inicio de la búsqueda
    let today = new Date();
    let dateIni = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    this.model1.initDate = dateIni;

    // Datos de estados
    this.setStatesToModel();
    // Datos de causas
    this.setCausesToModel();
    // Datos de causas
    this.setTypesToModel();

    this.subscribe(this.createFormConfig1(),
      (form1: FormConfig) => {
        this.formConfig1 = form1;
      });
  }



  private createFormConfig1(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'admin/substitutionsFilterISettings.json',
      this.model1
    ));
  }

  setStatesToModel(): void {
    let stateActive: string = this.translate.instant('Substitution.states.active');
    let stateInactive: string = this.translate.instant('Substitution.states.inactive');
    let stateCreated: string = this.translate.instant('Substitution.states.created');
    let stateFinished: string = this.translate.instant('Substitution.states.finished');

    this.model1.statesSelect =
      [

        {
          'label': stateActive,
          'value': 'ACTIVE'
        },
        {
          'label': stateCreated,
          'value': 'CREATED'
        },
        {
          'label': stateFinished,
          'value': 'FINISHED'
        },
        {
          'label': stateInactive,
          'value': 'INACTIVE'
        }
      ];
    this.model1.states = [];
    this.model1.states.push('ACTIVE');
    this.model1.states.push('CREATED');

  }

  setTypesToModel(): void {
    let temporal: string = this.translate.instant('Substitution.types.temporal');
    let definitive: string = this.translate.instant('Substitution.types.definitive');
    /*let change: string = this.translate.instant('Substitution.types.change');*/

    this.model1.types =
      [

        {
          'label': temporal,
          'value': 'TEMPORAL'
        },
        {
          'label': definitive,
          'value': 'DEFINITIVE'
        }/*,
        {
          "label": change,
          "value": "CHANGE"
        }*/
      ];

  }

  setCausesToModel(): void {
    let causeLeave: string = this.translate.instant('Substitution.causes.leave');
    let causeVacation: string = this.translate.instant('Substitution.causes.vacation');
    let causeSubstitution: string = this.translate.instant('Substitution.causes.substitution');
    let causeDelegation: string = this.translate.instant('Substitution.causes.delegation');
    let causeOthers: string = this.translate.instant('Substitution.causes.others');

    this.model1.causes = [];
    this.model1.causes = [
      {
        'label': causeLeave,
        'value': 'LEAVE'
      },
      {
        'label': causeVacation,
        'value': 'VACATION'
      },
      {
        'label': causeSubstitution,
        'value': 'SUBSTITUTION'
      },
      {
        'label': causeDelegation,
        'value': 'DELEGATION'
      },
      {
        'label': causeOthers,
        'value': 'OTHERS'
      }
    ];

  }
  ngAfterContentInit(): void {


    this.headerActionsService.setTaskDescription(this.elem, 'Substitution.title', 'fas fa-people-carry', this.isLoaded.bind(this));
    this.subscribe(
      this.headerActionsService.addAction(
        'Substitution.add',
        'fas fa-plus',
        'btn-primary',
        true
      ), success => {
        let substitutionDTO = new SubstitutionDTO();
        this.editSubstitution(substitutionDTO);
      });
    this.subscribe(
      this.headerActionsService.addAction(
        'General.clean',
        'fas fa-undo',
        'btn-secondary',
        true
      ), success => {
        let substitutionDTO = new SubstitutionDTO();
        this.clearFilter();
      });
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });

    this.loadSubstitutions();
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }



  public clearFilter(): void {
    // this.dtoToModel();
    this.model1.identifier = null;

    let today = new Date();
    let dateIni = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    this.model1.initDate = dateIni;

    this.model1.endDate = null;

    // Datos de estados
    this.setStatesToModel();
    // Datos de causas
    this.model1.cause = null;
    // Datos de causas
    this.model1.type = null;

    this.model1.replacedUser = null;
    this.model1.replacedOrganizationUnit = null;
    this.model1.substituteUser = null;
    this.model1.substituteOrganizationUnit = null;

  }



  loadSubstitutions() {
    this.loaded = false;
    this.subscribe(this.plycaService.query<SubstitutionDTO>(this.configuration.SUBSTITUTIONS_SERVICE_URL,
      this.getParams()).pipe(
        finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        })
      ),
      results => {
        if (results && results.content) {
          this.substitutions = results.content;
          this.substitutions.forEach(substitution => {
            substitution.stateTranslation = this.translateState(substitution.state);
            substitution.causeTranslation = this.translateCause(substitution.cause);
            substitution.typeTranslation = this.translateType(substitution.type);
          });


        } else {
          this.substitutions = [];
        }
        this.loaded = true;
      });
  }

  translateState(state: string): string {

    if (state === 'ACTIVE') {
      return this.translate.instant('Substitution.states.active');
    } else if (state === 'CREATED') {
      return this.translate.instant('Substitution.states.created');
    } else if (state === 'FINISHED') {
      return this.translate.instant('Substitution.states.finished');
    } else {
      return this.translate.instant('Substitution.states.inactive');
    }
  }

  translateCause(cause: string): string {

    if (cause === 'LEAVE') {
      return this.translate.instant('Substitution.causes.leave');
    } else if (cause === 'VACATION') {
      return this.translate.instant('Substitution.causes.vacation');
    } else if (cause === 'SUBSTITUTION') {
      return this.translate.instant('Substitution.causes.substitution');
    } else if (cause === 'DELEGATION') {
      return this.translate.instant('Substitution.causes.delegation');
    } else {
      return this.translate.instant('Substitution.causes.others');
    }
  }

  translateType(type: string): string {

    if (type === 'TEMPORAL') {
      return this.translate.instant('Substitution.types.temporal');
    } else if (type === 'DEFINITIVE') {
      return this.translate.instant('Substitution.types.definitive');
    }/* else if (type === 'CHANGE') {
      return this.translate.instant('Substitution.types.change');
    }*/
  }

  editSubstitution(substitution: SubstitutionDTO) {
    this.loadSubstitution(substitution, false, false);
  }

  copySubstitution(substitution: SubstitutionDTO) {
    this.loadSubstitution(substitution, true, false);
  }

  viewSubstitution(substitution: SubstitutionDTO) {
    this.loadSubstitution(substitution, false, true);
  }

  loadSubstitution(substitution: SubstitutionDTO, copy: boolean, view: boolean) {


    let config: DynamicDialogConfig = {
      header: this.translate.instant('Substitution.title'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'
    };

    let readOnly = view;
    config['id'] = substitution.identifier;
    config['readOnly'] = readOnly;
    config['copy'] = copy;

    const ref = this.dialogService.open(
      SubstitutionEditionComponent,
      config
    );

    this.subscribe(ref.onClose, result => {
      this.loadSubstitutions();
    });
  }



  getStatusStyle(substitution) {
    let style = 'badge badge-';
    if (substitution != null) {
      if (substitution.state === 'ACTIVE') {
        style += 'success';
      } else if (substitution.state === 'CREATED') {
        style += 'info';
      } else if (substitution.state === 'INACTIVE') {
        style += 'warning';
      } else if (substitution.state === 'FINISHED') {
        style += 'secondary';
      }
    }
    return style;
  }


  public confirmActive(substitution: SubstitutionDTO): void {

    let txt: string;
    if (substitution.state === 'ACTIVE' || substitution.state === 'CREATED') {
      txt = this.translate.instant('Substitution.inactiveConfirm');
    } else if (substitution.state === 'INACTIVE') {
      txt = this.translate.instant('Substitution.activeConfirm');
    } else {
      return;
    }

    txt = txt.replace('%s', substitution.identifier);
    this.confirmationService.confirm({
      message: txt,
      accept: () => {
        this.active(substitution);
      }
    });
  }

  active(substitution: SubstitutionDTO) {

    this.loaded = false;
    if (substitution != null
      && (substitution.state === 'ACTIVE' || substitution.state === 'CREATED')) {
      substitution.enabled = false;
    } else if (substitution != null
      && (substitution.state === 'INACTIVE')) {
      substitution.enabled = true;
    } else {
      return;
    }

    this.subscribe(this.plycaService.patch<SubstitutionDTO>(this.configuration.SUBSTITUTIONS_SERVICE_URL, substitution),
      () => {
        this.manageInfo();
        this.loaded = true;
      },
      (error: any) => this.manageError(error),
      () => {
        this.loadSubstitutions();
        this.waitService.cancelWaiting();
      }
    );
  }


  private manageInfo(): void {
    this.uiService.showMessage('Actualizacion Correcta');
  }

  private manageError(error: any): void {
    this.plycaErrorHandler.showServerError(error);
    this.loadSubstitutions();
    this.waitService.cancelWaiting();
  }

  getParams() {

    let params: any = {};

    if (this.formConfig1.model) {

      if (this.formConfig1.model.cause) {
        params.cause = this.formConfig1.model.cause;
      }

      if (this.formConfig1.model.identifier) {
        params.identifier = this.formConfig1.model.identifier;
      }

      if (this.formConfig1.model.initDate) {
        params.initDate = this.formConfig1.model.initDate.getTime();
      }

      if (this.formConfig1.model.endDate) {
        params.endDate = this.formConfig1.model.endDate.getTime();
      }

      if (this.formConfig1.model.states) {
        params.states = this.formConfig1.model.states;
      }

      if (this.formConfig1.model.type) {
        params.type = this.formConfig1.model.type;
      }

      if (this.formConfig1.model.replacedUser) {
        params.replacedUser = this.formConfig1.model.replacedUser.identifier;
      }

      if (this.formConfig1.model.substituteUser) {
        params.substituteUser = this.formConfig1.model.substituteUser.identifier;
      }

      if (this.formConfig1.model.replacedOrganizationUnit) {
        params.replacedOrganizationUnit = this.formConfig1.model.replacedOrganizationUnit.identifier;
      }

      if (this.formConfig1.model.substituteOrganizationUnit) {
        params.substituteOrganizationUnit = this.formConfig1.model.substituteOrganizationUnit.identifier;
      }

      if (this.formConfig1.model.type) {
        params.type = this.formConfig1.model.type;
      }
    }

    return params;

  }
}
